// NOTE: https://qiita.com/saba_can00/items/bdefb28a1873658cf5d9
export const MEMBER_STATUS = {
  temporary: "仮会員",
  waiting: "会員承認待ち",
  registered: "会員",
} as const;

type TypeOfMemberStatus = typeof MEMBER_STATUS;
export type TAppMemberStatus = TypeOfMemberStatus[keyof TypeOfMemberStatus];
